const getters = {
    shopId:(state) =>state.index.shopId,//本地储存商品id
    positionId:(state) =>state.index.positionId,//本地储存问题id
    languageType:(state) =>state.index.languageType,//本地储存语言类型
};
export default getters;
  